export default "__VITE_ASSET__DprHqIKC__"